// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.extra-payment-item{\n  margin-top:0 !important;\n  margin-bottom: 0 !important;\n}\n.extra-payment-item:nth-child(odd){\n  background-color: #f6f6f6;\n}\n.extra-payment-status{\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  flex-grow:0;\n}\n", ""]);
// Exports
module.exports = exports;
